export enum KnowledgeBaseStatus {
  DRAFT = 1,
  PUBLISHED = 2,
  ARCHIVED = 3,
}

export enum KnowledgeBaseAudience {
  MANAGER = 1,
  CLIENT = 2,
}

export enum KnowledgeBaseCategory {
  OTHER = 1,
  PROJECTS = 2,
  CLIENTS = 3,
  CONSUMER_UNITS = 4,
  INVOICES = 5,
  SAVINGS = 6,
  BILLING = 7,
  CREDITS = 8,
  PANELS = 9,
  SETTINGS = 10,
  ALERTS = 11,
}

export enum KnowledgeBaseType {
  ARTICLE = 1,
  TUTORIAL = 2,
  FAQ = 3,
}

export enum KnowledgeBaseSortField {
  TITLE = "title",
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  PUBLISHED_AT = "publishedAt",
}

export const KNOWLEDGE_BASE_STATUS_OPTIONS = [
  { value: String(KnowledgeBaseStatus.DRAFT), label: "Rascunho" },
  { value: String(KnowledgeBaseStatus.PUBLISHED), label: "Publicado" },
  { value: String(KnowledgeBaseStatus.ARCHIVED), label: "Arquivado" },
];

export const KNOWLEDGE_BASE_AUDIENCE_OPTIONS = [
  { value: String(KnowledgeBaseAudience.MANAGER), label: "Gestora" },
  { value: String(KnowledgeBaseAudience.CLIENT), label: "Cliente" },
];

export const KNOWLEDGE_BASE_CATEGORY_OPTIONS = [
  { value: String(KnowledgeBaseCategory.PROJECTS), label: "Projetos" },
  { value: String(KnowledgeBaseCategory.CLIENTS), label: "Clientes" },
  { value: String(KnowledgeBaseCategory.CONSUMER_UNITS), label: "Unidades consumidoras" },
  { value: String(KnowledgeBaseCategory.INVOICES), label: "Faturas" },
  { value: String(KnowledgeBaseCategory.SAVINGS), label: "Economias" },
  { value: String(KnowledgeBaseCategory.BILLING), label: "Faturamento" },
  { value: String(KnowledgeBaseCategory.CREDITS), label: "Gestão de créditos" },
  { value: String(KnowledgeBaseCategory.PANELS), label: "Painéis" },
  { value: String(KnowledgeBaseCategory.SETTINGS), label: "Configurações" },
  { value: String(KnowledgeBaseCategory.ALERTS), label: "Alertas" },
  { value: String(KnowledgeBaseCategory.OTHER), label: "Outros" },
];

export const KNOWLEDGE_BASE_TYPE_OPTIONS = [
  { value: String(KnowledgeBaseType.ARTICLE), label: "Artigo" },
  { value: String(KnowledgeBaseType.TUTORIAL), label: "Tutorial" },
  { value: String(KnowledgeBaseType.FAQ), label: "Pergunta frequente" },
];

const labelOf = (options: { value: string; label: string }[], value: number) =>
  options.find((option) => option.value === String(value))?.label ?? "—";

export const knowledgeBaseStatusLabel = (value: number) => labelOf(KNOWLEDGE_BASE_STATUS_OPTIONS, value);

export const knowledgeBaseCategoryLabel = (value: number) => labelOf(KNOWLEDGE_BASE_CATEGORY_OPTIONS, value);

export const knowledgeBaseTypeLabel = (value: number) => labelOf(KNOWLEDGE_BASE_TYPE_OPTIONS, value);

export const knowledgeBaseAudienceLabel = (audiences: number[]) => {
  const labels = [...audiences]
    .sort((left, right) => left - right)
    .map((audience) => labelOf(KNOWLEDGE_BASE_AUDIENCE_OPTIONS, audience))
    .filter((label) => label !== "—");

  return labels.length ? labels.join(" e ") : "—";
};
